import { useCallback, useState } from 'react'

/**
 * Companion hook for the GlobalCommandView orchestrator.
 *
 * Holds the discriminator that flips the orchestrator between the GS and
 * GI branches: `conversationId === null` → Global Search, otherwise Guided
 * Intake. `startConversation` is invoked by the GS presenter's `onHandoff`
 * callback when the BE response surfaces a `conversation_id`
 */
export const useGlobalCommandView = () => {
  const [conversationId, setConversationId] = useState<Nullable<string>>(null)

  const startConversation = useCallback((id: string) => {
    setConversationId(id)
  }, [])

  const endConversation = useCallback(() => {
    setConversationId(null)
  }, [])

  return {
    data: { conversationId },
    methods: { startConversation, endConversation },
    states: { isConversation: conversationId !== null },
  }
}
